import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79279a1c")

_pushScopeId("data-v-79279a1c")
const _hoisted_1 = {
  key: 0,
  class: "item-edit-mode"
}
const _hoisted_2 = { class: "item-edit-mode-name" }
const _hoisted_3 = { class: "item-edit-mode-actions" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-check fs-14" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-delete-cross fs-10",
  style: {"color":"#fd695a"}
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "item"
}
const _hoisted_7 = { class: "item-name" }
const _hoisted_8 = { class: "item-actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.itemToEdit && _ctx.itemToEdit.id == _ctx.item.id)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.itemToEdit.mainLang.name = $event))
          }, null, 512), [
            [_vModelText, _ctx.itemToEdit.mainLang.name]
          ])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyChanges()))
          }, [
            _hoisted_4
          ]),
          _createVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rejectChanges(_ctx.tagIndex)))
          }, [
            _hoisted_5
          ])
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.item.mainLang.name), 1),
        _createVNode("div", _hoisted_8, [
          _createVNode("i", {
            class: "icon-f icon-earth-shape fs-18 sub-tag-langs",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editLangs()))
          }),
          _createVNode("i", {
            class: "icon-f icon-pencil-edit fs-18 sub-tag-edit",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editItem()))
          }),
          _createVNode("i", {
            class: "icon-f icon-trash fs-18",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteItem())),
            style: {"color":"#adacb7"}
          })
        ])
      ]))
})